import React from 'react'

export const districtColumbiaSetupVars = {
  siteId: 'district_of_columbia',
  pathPrefix: '/dc',
  menuHeader: "Discover Washington, D.C.'s Solution for:",
  appUrl: 'https://dc.headed2.com',
  logoImg: `/images/assets/district_of_columbia/horizontal/dark.svg`,
  headerTitle: `The D.C. CareerExplorer is a system designed for Washington, D.C.`
}
